"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseTypeCode = void 0;
var LicenseTypeCode;
(function (LicenseTypeCode) {
    LicenseTypeCode["UNKNOWN"] = "Unknown";
    LicenseTypeCode["COMMERCIAL"] = "Commercial";
    LicenseTypeCode["BETA"] = "Beta";
    LicenseTypeCode["TRIAL"] = "Trial";
    LicenseTypeCode["TEST"] = "Test";
    LicenseTypeCode["OEM"] = "Oem";
    LicenseTypeCode["SUBSCRIPTION"] = "Subscription";
    LicenseTypeCode["SUBSCRIPTION_LIMIT"] = "SubscriptionLimit";
    LicenseTypeCode["FREE"] = "Free";
})(LicenseTypeCode || (exports.LicenseTypeCode = LicenseTypeCode = {}));
